import React from "react";
import { FusionLayout } from "@/parts/fusion-layout";
import sizes from "../ui/sizes.scss";
import { Stack } from "@fluentui/react";
import { Section } from "../ui/atoms/section";
import { useTranslation } from "react-i18next";
import { createUuid } from "../utils/uuid";
import { ListEloshieldClassicStationaryModules } from "../ui/molecules/list-eloshield-classic-stationary-modules";
import { ListCommandButtonsEloshieldClassicStationaryModules } from "../ui/organisms/list-command-buttons-eloshield-classic-stationary-modules";
import { observer } from "mobx-react";

export const PageEloshieldClassicStationaryModules = observer((): JSX.Element => {
    const { t } = useTranslation();
    const eloshieldClassicStationaryModuleListStateId = createUuid();

    return (
        <FusionLayout breadcrumb={t("page.eloshieldClassicStationaryModules.title")} classic>
            <Section fill>
                <ListEloshieldClassicStationaryModules
                    commandBar={
                        <Stack horizontal style={{ alignItems: "center" }}>
                            <ListCommandButtonsEloshieldClassicStationaryModules
                                listStateId={eloshieldClassicStationaryModuleListStateId}
                            />
                        </Stack>
                    }
                    listStateId={eloshieldClassicStationaryModuleListStateId}
                    maxHeight={`${sizes.listMaxHeight}`}
                />
            </Section>
        </FusionLayout>
    );
});
